import React from 'react'
import PropTypes from 'prop-types'
import { Ribbon } from './SoldRibbonStyledComponents'

const SoldRibbon = React.memo(({ show, children, ...rest }) => {
  return show && <Ribbon {...rest}>{children}</Ribbon>
})

SoldRibbon.displayName = 'SoldRibbon'

SoldRibbon.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

export default SoldRibbon
